export default __webpack_public_path__ + "static/media/background_print2.9985e008.png";